<ng-template #UserAvatar let-avatarWidth="avatarWidth" let-avatarShowStatus="avatarShowStatus">
  <app-lightweight-user-avatar
    [isUser]="!!user"
    [profileImage]="user?.profile_image"
    [userRole]="user?.role"
    [userEmail]="user?.email"
    [userName]="user?.name"
    [width]="avatarWidth"
    [fontSize]="fontSize"
    [fontWeight]="fontWeight"
    [fontColor]="fontColor"
    [showStatus]="avatarShowStatus"
    [userStatus]="userStatus"
    [opaqueOverlay]="opaqueOverlay"
    [isInstitution]="!!institution"
    [institutionLogo]="institution?.logo"
    [institutionName]="institution?.name"
    [showName]="showName"
    [showYouWord]="showYouWord"
    [imgScale]="imgScale"
    [enableImageBorder]="enableImageBorder"
    [parentDisplay]="parentDisplay"
    [imgBorder]="imgBorder"
    [showHostTag]="showHostTag"
    [showAnimatedImageBorder]="showAnimatedImageBorder"
    (click)="!hasMenu && profileClicked()"
  >
  </app-lightweight-user-avatar>
</ng-template>

<ng-template #userDetails>
  <div class="user-details">
    <div class="picture">
      <ng-container
        *ngTemplateOutlet="UserAvatar; context: { avatarWidth: 48, avatarShowStatus: false }"
      ></ng-container>
    </div>
    <div class="info" *ngIf="user?.name || user?.email">
      <div #name class="name" *ngIf="user?.name">
        <app-clip-text [text]="user?.name"></app-clip-text>
      </div>
      <div #email class="email" *ngIf="!user?.isAnonymous && user?.email">
        <app-clip-text [text]="user?.email"></app-clip-text>
      </div>
    </div>
  </div>
</ng-template>

<div
  #profileMenuTrigger="matMenuTrigger"
  [matMenuTriggerFor]="isDesktop ? profileMenu : null"
  [style.pointer-events]="hasMenu ? 'all' : 'none'"
  (click)="openProfileBottomSheet()"
>
  <ng-template
    *ngTemplateOutlet="UserAvatar; context: { avatarWidth: width, avatarShowStatus: showStatus }"
  ></ng-template>
</div>

<mat-menu
  #profileMenu="matMenu"
  [hasBackdrop]="true"
  [class]="'pencil-mat-menu light-scheme avatar-menu' + (isRTL ? ' rtl' : '')"
>
  <ng-container *ngTemplateOutlet="userDetails"></ng-container>
  <app-pncl-menu-divider></app-pncl-menu-divider>
  <app-language-submenu-item></app-language-submenu-item>

  <ng-container *ngTemplateOutlet="profileMenuActions"></ng-container>
</mat-menu>

<ng-template #profileMenuActions let-showSettingsChevron="showSettingsChevron">
  <app-pencil-menu-item
    id="btn-home-avatar-menu-settings"
    *ngIf="!user?.isAnonymous && showSettings"
    data-name="spaces-manager-user-avatar-menu-settings"
    [forMenu]="!!showSettingsChevron"
    icon="settings"
    [iconConfig]="{ type: IconTypes.materialIcon, outlined: true }"
    [label]="'Settings' | translate"
    (clickEvent)="openSettingsPanel()"
  ></app-pencil-menu-item>
  <app-pencil-menu-item
    data-name="spaces-manager-user-avatar-menu-logout"
    icon="logout"
    [iconConfig]="{ type: IconTypes.materialIcon }"
    [label]="'Sign-out' | translate"
    (clickEvent)="signOut()"
  ></app-pencil-menu-item>
  <app-pencil-menu-item
    data-name="spaces-manager-user-avatar-menu-help"
    icon="help_outline"
    [iconConfig]="{ type: IconTypes.materialIcon, outlined: true }"
    [label]="'Help' | translate"
    (clickEvent)="openHelp()"
  ></app-pencil-menu-item>
</ng-template>

<ng-template #bottomSheetContainer>
  <app-pencil-bottom-sheet-container
    class="profile-avatar-bottom-sheet"
    [title]="'You' | translate"
    [colorScheme]="ColorScheme.LIGHT"
    [fullscreen]="true"
    (closeClicked)="closeProfileMenu()"
  >
    <ng-container *ngTemplateOutlet="userDetails"></ng-container>
    <app-pncl-menu-divider></app-pncl-menu-divider>
    <ng-container
      *ngTemplateOutlet="profileMenuActions; context: { showSettingsChevron: true }"
    ></ng-container>
  </app-pencil-bottom-sheet-container>
</ng-template>
